'use client'

import { useEffect } from 'react'
import { useAmplitude } from '@wiggot/analytics/src/providers/amplitud-provider/AmplitudeProvider'
import { Text } from '@dd3tech/wiggui/Text'
import { Button } from '@dd3tech/wiggui/Button'
import { Modal } from '@dd3tech/wiggui/Modal'
import { VARIANTS_PLANS } from '../../constants'
import { EModalServicesAmplitude } from '../../enum'
import { useLogicModalPlans } from './hooks'

export const ModalPlans = () => {
  const { trackEvent, isInitialized } = useAmplitude()
  const { closeModal, assignedNameVariant, isOpen } = useLogicModalPlans()

  useEffect(() => {
    if (isInitialized && VARIANTS_PLANS[assignedNameVariant]?.amplitudeKind) {
      trackEvent({
        name: EModalServicesAmplitude.TRIAL_START_VIEW,
        eventProperties: {
          kind: VARIANTS_PLANS[assignedNameVariant]?.amplitudeKind
        },
        configs: {
          login: true
        }
      })
    }
  }, [isInitialized])

  return (
    <Modal
      enableBgBlur
      isOpen={isOpen}
      onClose={() => {
        closeModal()
      }}
      buttomSheetClassName="!bg-surface-dark"
    >
      <Modal.Header
        className="flex md:rounded-t-xl bg-surface-dark border-b-[#2B3946] px-6 py-3 border-b items-center justify-between gap-3 w-full flex-row"
        title={
          assignedNameVariant ? VARIANTS_PLANS[assignedNameVariant]?.title : ''
        }
        isShowCloseButton={
          VARIANTS_PLANS[assignedNameVariant]?.showButtonCancel
        }
      >
        <Text className="text-body-bold-xl text-white">
          {assignedNameVariant
            ? VARIANTS_PLANS[assignedNameVariant]?.title
            : ''}
        </Text>
      </Modal.Header>
      {assignedNameVariant && (
        <Modal.Footer className="bg-surface-dark md:rounded-b-xl flex-row gap-3 flex py-3 border-t border-b-[#2B3946] items-center w-full px-6 justify-between">
          {VARIANTS_PLANS[assignedNameVariant]?.secondaryActionLabel &&
            VARIANTS_PLANS[assignedNameVariant].showButtonCancel && (
              <Button
                fullWidth
                variant="secondary"
                className="!bg-primary"
                onClick={(event) => {
                  event.stopPropagation()
                  closeModal()
                }}
              >
                {VARIANTS_PLANS[assignedNameVariant]?.secondaryActionLabel}
              </Button>
            )}
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default ModalPlans
